import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/beeville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Beeville, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Beeville & Bee County. Free quotes — +1 (830) 390-9588.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Beeville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Beeville and Bee County.",
      keywords: "awnings Beeville, awning company Beeville, custom awnings Beeville, sail shades Beeville, patio covers Beeville, pergola covers Beeville, metal awnings Beeville, canvas awnings Beeville, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Beeville", "Bee County"),
  }),
  component: () => <CityHomePage city="Beeville" region="Bee County" />,
});
